import useTabManager from '@/pages/function/hook/useTabManager';
import { FUNC_CONV_TAB_BUTTON } from '@/pages/function/constants';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useEffect, useRef } from 'react';
import type { Swiper as SwiperType } from 'swiper/types';
import 'swiper/css';
import 'swiper/css/navigation';

const ConvenienceTabButtonListBox = () => {
	const { funcClickTab } = useTabManager();
	const swiperRef = useRef<SwiperType | null>(null);

	useEffect(() => {
		const hash = window.location.hash.replace('#', '');
		const targetIndex = FUNC_CONV_TAB_BUTTON.findIndex(tab => tab.hash === hash);
		if (targetIndex !== -1 && swiperRef.current) {
			swiperRef.current.slideTo(targetIndex);
		}
	}, []);

	const onTabClick = (index: number) => {
		window.location.hash = FUNC_CONV_TAB_BUTTON[index].hash;
		swiperRef.current?.slideTo(index);
		funcClickTab(index, 'conv');
	};

	return (
		<div className="sub-tab">
			<Swiper
				modules={[Navigation]}
				spaceBetween={16}
				watchOverflow={false}
				slidesPerView="auto"
				navigation={{
					nextEl: '.swiper-nav .swiper-button-next',
					prevEl: '.swiper-nav .swiper-button-prev'
				}}
				observer={true}
				observeParents={true}
				onSwiper={(swiper: any) => {
					swiperRef.current = swiper;
				}}>
				{FUNC_CONV_TAB_BUTTON.map((item, idx) => (
					<SwiperSlide key={item.key}>
						<button className="tab-btn" onClick={() => onTabClick(idx)}>
							{item.label}
						</button>
					</SwiperSlide>
				))}
			</Swiper>
			<div className="swiper-nav">
				<div className="swiper-button-prev"></div>
				<div className="swiper-button-next"></div>
			</div>
		</div>
	);
};

export default ConvenienceTabButtonListBox;
